import React, { useState, useEffect } from 'react';
import { List, Card, Header } from 'semantic-ui-react';
import { intToNote } from '../../util/notes';

export const RangeDisplay = ({ ranges, vtMap }) => {
    //console.log("range display", ranges);
    if (!ranges || ranges.length === 0) {
        return (<div>No range data.</div>);
    } 

    const cards = ranges.map((r, i) => {
        const regex = /#\d+#/g;
        const vt = regex.test(r.voice_type) ?
            vtMap[parseInt(r.voice_type.slice(1,-1))].name : "Invalid Voice Type";

        
        let range = "";
        if (r.ossia_low && r.ossia_low < r.low && r.ossia_low !== 48) {
            range += intToNote(r.ossia_low) + " (ossia) - ";
        }
        range += intToNote(r.low) + " - " + intToNote(r.high);
        if (r.ossia_high && r.ossia_high > r.high && r.ossia_high !== 48) {
            range += " - " + intToNote(r.ossia_high) + " (ossia)";
        }

        return (
            <List.Item key={i}>
                <Card className="instrumentation-card">
                    <Card.Header>
                        <Header as='h4' color='green' className='subtitle'>{vt}</Header>
                    </Card.Header>
                    {range}
                </Card>
            </List.Item>
        );
    });

    return (
        <List size='big'>
            {cards}
        </List>
    );
}